import React from "react";
import { Link } from "react-router-dom";
import { CustomerServiceSidebar } from "./Delivery";
import "../css/content-page.scss";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

function CookiePolicy() {
  return (
    <main className="content-page cookie-policy-page">
      <div className="content-page__shell">
        <CustomerServiceSidebar currentPath="/cookies" />
        <article className="content-page__article" aria-labelledby="cookies-title">
          <header className="content-page__header">
            <p className="content-page__eyebrow">Your browser choices</p>
            <h1 id="cookies-title">Cookie Policy</h1>
            <p className="content-page__lead">
              This policy explains the cookies and browser storage used by the
              sickzuno storefront and the hosted payment experience.
            </p>
          </header>
          <p className="content-page__meta">Last updated: October 16, 2026</p>

          <div className="content-page__notice" role="note">
            <strong>Current storefront:</strong> sickzuno uses browser storage for
            the cart and recent order summary. The application code does not set
            advertising or cross-site behavioral tracking cookies.
          </div>

          <section className="content-page__section" aria-labelledby="cookies-meaning">
            <h2 id="cookies-meaning">1. Cookies and similar storage</h2>
            <p>
              Cookies are small text records a website can place in a browser.
              Local storage and session storage are separate browser features, but
              they serve similar purposes and are covered by this policy for clarity.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-current">
            <h2 id="cookies-current">2. Storage used by sickzuno</h2>
            <div className="content-page__table-wrap">
              <table className="content-page__table">
                <caption className="content-page__visually-hidden">
                  Browser storage used by sickzuno
                </caption>
                <thead>
                  <tr>
                    <th scope="col">Storage</th>
                    <th scope="col">Purpose</th>
                    <th scope="col">Duration</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Local storage: cartItems</td>
                    <td>Remembers product IDs, options, packaging and quantities in the cart.</td>
                    <td>Until the cart or this site’s browser data is cleared.</td>
                  </tr>
                  <tr>
                    <td>Session storage: sickzuno:lastOrder</td>
                    <td>Displays the recent order reference, email, item count, total and time on the payment-result page.</td>
                    <td>For the browser session or until site data is cleared.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-essential">
            <h2 id="cookies-essential">3. Why this storage is used</h2>
            <p>
              These records support functions a shopper requests: keeping items in
              the cart and showing an order result after the hosted payment flow.
              They are not used by the application code to build advertising profiles.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-third-party">
            <h2 id="cookies-third-party">4. Third-party payment page</h2>
            <p>
              After Pay now is selected, the customer leaves the storefront for a
              hosted payment page. The payment provider may use cookies or similar
              technology for security, fraud prevention, authentication and payment
              processing under its own cookie and privacy notices.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-choices">
            <h2 id="cookies-choices">5. Managing browser storage</h2>
            <p>
              Browser settings can display, block or delete site data. Blocking local
              or session storage may prevent the cart from persisting or the payment
              result from showing the saved order summary. Payment-provider controls
              must be managed on the provider’s page or through browser settings.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-consent">
            <h2 id="cookies-consent">6. Consent and future changes</h2>
            <p>
              The current application does not configure analytics, personalization
              or advertising cookies. Before optional tracking is added, sickzuno will
              update this policy and provide any notice or consent control required by
              applicable law.
            </p>
          </section>

          <section className="content-page__section" aria-labelledby="cookies-contact">
            <h2 id="cookies-contact">7. Questions</h2>
            <p>
              Email <a className="content-page__inline-link" href="mailto:harv@sickzuno.online">harv@sickzuno.online</a>{" "}
              or review the{" "}
              <Link className="content-page__inline-link" to="/privacy" onClick={scrollToTop}>
                Privacy Policy
              </Link>{" "}
              and{" "}
              <Link className="content-page__inline-link" to="/privacy-choices" onClick={scrollToTop}>
                Your Privacy Choices
              </Link>
              .
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default CookiePolicy;
